import React from 'react';
import { generateRandomObservation, loadDemoProfile } from '../../utils/demoUtils';
//import { MESSAGE_TYPES } from '../../utils/constants';

const DemoControls = ({ onSubmitMessage, setMessages, setInputText }) => {
  const handleDemoMessage = () => {
    const observation = generateRandomObservation();
    onSubmitMessage(observation);
  };

  const handleAddDemoProfile = () => {
    const demoMessages = loadDemoProfile();
    setMessages(prevMessages => [...prevMessages, ...demoMessages]);

    // Simulate typing a benign observation into the input field
    const benignObservationText = 'Sarah joined my homeroom.';
    setInputText(benignObservationText);
  };

  return (
    <div className="fixed bottom-4 left-4 flex gap-2 bg-white p-4 rounded-lg shadow-lg">
      <button
        onClick={handleDemoMessage}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Demo
      </button>
      <button
        onClick={handleAddDemoProfile}
        className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
      >
        Add Demo Profile
      </button>
    </div>
  );
};

export default DemoControls;